import { useMutation } from "@tanstack/react-query";
import { login } from "../../../api/requests/login";
import { useAuthStore } from "../../store/authStore";
import { useNotificationStore } from "@src/shared/components/Notification";
import { AxiosError } from "axios";

export const useLogIn = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: login,
    onSuccess: (response) => {
      useAuthStore.getState().setUser({
        user: response.data.user,
        tokens: {
          access_token: response.data.tokens.access,
        },
      });
    },
    onError: (error: AxiosError) => {
      const response = error?.response?.data as {
        detail: string;
      };
      const errorMessage = response?.detail || "";

      if (
        errorMessage.includes("Invalid login or password. Please, try again.")
      ) {
        showAlert(
          "Неверный логин или пароль. Пожалуйста, попробуйте еще раз.",
          "error",
        );
        return;
      }

      showAlert(error.message, "error");
    },
  });
  return query;
};
